<template>
    <div class="width100">

        <h3 class="titreSolu text-center">Echéances</h3>

        <Aide v-bind:token="token" v-bind:site="site" v-bind:racine="racine"
              v-bind:user="user" v-bind:idAide="9"></Aide>


        <div v-if="niveau == 1" class="row" style="overflow: scroll;height:250px;">
            <div v-for="(machineTypeL, keyMachineT) in listMachineType" :key="keyMachineT" class="colSolu col-md-12 col-lg-4">
                <div class="thtab userList col-12 text-center rounded"
                     @click="choixMachineType(machineTypeL)">
                    {{machineTypeL.intitule}}
                </div>
            </div>
        </div>
        <div v-if="niveau == 2" class="row">
            <div class="col-12 text-center">
                <h3>{{machineType.intitule}}</h3>
            </div>
            <div v-if="spin==true" class="text-center">
                <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
            </div>
            <div v-if="spin==false">

                <table class="table table-striped table-hover table-bordered" v-if="listTache">
                    <tr>
                        <th class="thtab"></th>
                        <th class="thtab" v-for="(tacheL, keyTache) in listTache" :key="keyTache">
                            {{tacheL.intitule}}
                        </th>
                    </tr>
                    <tr v-for="(machineL, keyMachine) in listMachine" :key="keyMachine">
                        <td class="col-2 thtab">
                            <b>{{machineL.nom}}</b>
                        </td>
                        <td v-for="(tacheValue, keyTacheValue) in machineL.listDateTache" :key="keyTacheValue"
                            :class="tacheValue.style">
                            <b>{{tacheValue.date}}</b>
                        </td>
                    </tr>
                </table>

                <div v-if="listTache==null" class="alert alert-warning text-center" role="alert">Aucune tache n'a de rappel.</div>
            </div>
        </div>

        <div v-if="niveau>1" class="text-center">
            <br />
            <button class="btn btn-danger" block @click="returnNiveau()">Retour</button>
        </div>
    </div>
</template>

<script>
    import Aide from './Aide';

    export default {
        name: "Echeance",
        props: ['token', 'site', 'user', 'racine', 'machine', 'tache', 'userId', 'idModif',
            'systemeClient','systemeClientId'],
        data() {
            return {
                listMachine:null,listMachineType:null,niveau:1,machineType:null,listTache:null,
                spin:true
            };
        },
        methods:
        {
            tokenValide(json) {
                if (json['status'] == '401') {
                    this.$emit('token')
                }
            },
            getMachineTypes()
            {
                fetch(this.racine + this.site + 'api/machine_types?systemeClient='+this.systemeClientId, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.token
                    },
                }).then(response => {
                    this.tokenValide(response)
                    console.log(response)
                    response.json().then(json => {
                        if (json != undefined) {
                            console.log(json)
                            this.listMachineType = json['hydra:member']

                        }
                    })
                })
            },
            getTableauEcheance()
            {
                this.spin = true
                fetch(this.racine + this.site + 'api/get_tableau_echeance/'+this.systemeClientId+'/'+this.machineType.id, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.token
                    },
                }).then(response => {
                    this.tokenValide(response)
                    console.log(response)
                    response.json().then(json => {
                        if (json != undefined) {
                            console.log(json)
                            this.listMachine = json['listMachine']
                            this.listTache = json['listTache']
                            this.spin = false
                        }
                    })
                })
            },
            choixMachineType(machineT)
            {
                this.machineType = machineT
                this.niveau = 2
                this.getTableauEcheance()

            },
            returnNiveau()
            {
                this.niveau = this.niveau -1
                this.machineType = null
                this.listMachine = null
                this.listTache = null
            }

        },
        created() {
            this.getMachineTypes()
        },
        components: {
            Aide,
        }
    }
</script>

<style scoped>

</style>